module.exports = __webpack_public_path__ + "img/pepsi.8fbfc335.jpg";